import React, { useState, useEffect } from 'react';

import Title from '../../components/Title';
import { ArrowBold } from '../../static';
import { timeHelper } from '../../helper/timeHelper';

import './styles.scss';

const PatientVirus = ({documentsForVirus}) => {
	const [state,setState] = useState({
		time: '',
		position: '',
		virusName: '',
		authorFullName: ''
	});

	useEffect(() => {
		if(documentsForVirus.virusDocments.length > 1) {
			documentsForVirus.virusDocments
				.sort( (docA, docB) => docA.timestamp.seconds - docB.timestamp.seconds)
				.reverse()
			
			setDataState(documentsForVirus.virusDocments[0]);
		} else {
			setDataState(documentsForVirus.virusDocments[0]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [documentsForVirus]);

	const setDataState = (document) => {
		const timeOfСreation = timeHelper(document.timestamp.seconds);
		const position = document.docAuthor === "doctor" ? "Dr" : '';
		setState({
			time: timeOfСreation,
			position,
			virusName: documentsForVirus.virusName,
			authorFullName: document.authorFullName
		});
	};

	return (
	<div className="patient__virus">
		<Title text={state.virusName} isTexStart isLight isBold/>
		<div className="patient__virus-desc">
			{`${state.time} ago | Document added by ${state.position ? state.position : ''} ${state.authorFullName}`}
		</div> 
		<div className="patient__virus-icon">
			<ArrowBold />
		</div>
	</div>
	);
};

export default PatientVirus;
